import axios from 'axios'
import { host } from '../../../helper/config'
import { FULL_LIST_ITEM_PER_PAGE, getItemPerPage } from '../../../helper/helper'

const PLUGINS_NAME = 'admin-statistic'

// GET LIST
export const getListReward = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list-reward`, {
        ...query,
        page: page,
        itemPerPage: getItemPerPage()
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

// GET CSV
export const getCsvReward = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-csv-reward`, {
        ...query,
        page: page,
        itemPerPage: FULL_LIST_ITEM_PER_PAGE
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

// GET SUMMARY
export const getSummaryReward = async (token, query) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-summary-reward`, query, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}


